<template>
  <div class="product-page-items-list">
    <div class="product-page-items-list__toggle-btn">
      <span @click="toggleAll" v-if="productItems.length > 1">
        {{ allExpanded ? langJson[lang].minimizeAll : langJson[lang].expandAll }}
        <span :class="!allExpanded ? 'product-page-items-list__plus' : 'product-page-items-list__minus'"></span>
      </span>
    </div>
    <page-item
      v-for="(item, index) in productItems"
      :key="index"
      :item="item"
      :index="index"
      :allExpanded="allExpanded"
      @onToggle="toggleItem"
    />
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';
  import { privacyTypes } from '@/constants';

  interface ProductItem {
    id: string;
    publishedTo: number;
    active?: boolean;
    [key: string]: any;
  }

  const props = defineProps<{
    items?: ProductItem[];
  }>();

  const mainStore = useMainStore();
  const langJson = computed(() => mainStore.langJson);
  const lang = computed(() => mainStore.lang);

  const allExpanded = ref<boolean>(false);
  const productItems = ref<ProductItem[]>((props.items || []).map((item) => ({ ...item })));

  const productItemsExternalCount = computed(
    (): number => productItems.value.filter((item) => item.publishedTo === privacyTypes.EXTERNAL).length
  );
  const expandedProductCount = computed((): number => productItems.value.filter((item) => item.active).length);

  function toggleAll(): void {
    productItems.value = productItems.value.map((item) => ({
      ...item,
      active: !allExpanded.value
    }));
    allExpanded.value = !allExpanded.value;
  }

  function toggleItem(index: number): void {
    productItems.value[index] = {
      ...productItems.value[index],
      active: !productItems.value[index].active
    };
    if (expandedProductCount.value === 0) {
      allExpanded.value = false;
    } else if (expandedProductCount.value === productItems.value.length) {
      allExpanded.value = true;
    }
  }

  // Initialize active state for external items if only one
  productItems.value = productItems.value.map((item) => {
    item.active = productItemsExternalCount.value === 1 && item.publishedTo === privacyTypes.EXTERNAL;
    return item;
  });
</script>
